import React from 'react';
import web1 from '../../../assets/web1.png';
import web2 from '../../../assets/web2.png';
import web3 from '../../../assets/web3.png';
import {Helmet} from "react-helmet";

const Webdevelopment = () => {
    return (
        <div className="grid sm:grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4 lg:mt-6 mt-4 items-center">
        <Helmet>
        <title>Web-development project</title>
        <meta name='portfolio' content='Mahabuba akter morsana - web project' />
        </Helmet>
        <div className="max-w-sm bg-gray-800 rounded-lg shadow transition duration-300 transform border border-[#976db2] hover:scale-105 group hover:shadow-xl">
     <a href="https://art-masters.web.app/" target="_blank" rel="noreferrer">
         <img className="rounded-t-lg" src={web1} alt="" />
     </a>
     <div className="p-5">
         <p className="mb-3 font-normal text-gray-400">ART Master's Website</p>
         <div className="flex justify-evenly">
         <a href="https://art-masters-server.vercel.app/services" target="_blank" rel="noreferrer" type="button" className="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-[#976DB2] hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 shadow-md shadow-purple-400/40 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2">SERVER SITE</a>
         <a href="https://art-masters.web.app/" target="_blank" rel="noreferrer" type="button" className="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-[#976DB2] hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 shadow-md shadow-purple-400/40 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2">CLIENT SITE</a>
         </div>
     </div>
        </div>
        <div className="max-w-sm bg-gray-800 rounded-lg shadow transition duration-300 transform border border-[#976db2] hover:scale-105 group hover:shadow-xl">
     <a href="https://feather-online-library.web.app/" target="_blank" rel="noreferrer">
         <img className="rounded-t-lg" src={web2} alt="" />
     </a>
     <div className="p-5">
         <p className="mb-3 font-normal text-gray-400">Feather
Online Library Website
</p>
         <div className="flex justify-evenly">
         <a href="https://learning-platform-server-side.vercel.app/research" target="_blank" rel="noreferrer" type="button" className="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-[#976DB2] hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 shadow-md shadow-purple-400/40 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2">SERVER SITE</a>
         <a href="https://feather-online-library.web.app/" target="_blank" rel="noreferrer" type="button" className="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-[#976DB2] hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 shadow-md shadow-purple-400/40 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2">CLIENT SITE</a>
         </div>
     </div>
        </div>
        
        <div className="max-w-sm bg-gray-800 rounded-lg shadow transition duration-300 transform border border-[#976db2] hover:scale-105 group hover:shadow-xl">
     <a href="https://book-backs.web.app/" target="_blank" rel="noreferrer">
         <img className="rounded-t-lg" src={web3} alt="" />
     </a>
     <div className="p-5">
         <p className="mb-3 font-normal text-gray-400">Book Back Resale Website</p>
         <div className="flex justify-evenly">
         <a href="https://book-back-server.vercel.app/categories" target="_blank" rel="noreferrer" type="button" className="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-[#976DB2] hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 shadow-md shadow-purple-400/40 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2">SERVER SITE</a>
         <a href="https://book-backs.web.app/" target="_blank" rel="noreferrer" type="button" className="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-[#976DB2] hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 shadow-md shadow-purple-400/40 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2">CLIENT SITE</a>
         </div>
     </div>
        </div>
        </div>
    );
};

export default Webdevelopment;